import React from "react";

const CustomerOnboarding = () => {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-h-64 tw-text-2xl tw-font-light">
      Customer Onboarding Portal
    </div>
  );
};

export default CustomerOnboarding;
